import { render, staticRenderFns } from "./AnimationsModule.vue?vue&type=template&id=d1f3b478&scoped=true"
import script from "./AnimationsModule.vue?vue&type=script&lang=js"
export * from "./AnimationsModule.vue?vue&type=script&lang=js"
import style0 from "./AnimationsModule.vue?vue&type=style&index=0&id=d1f3b478&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f3b478",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1f3b478')) {
      api.createRecord('d1f3b478', component.options)
    } else {
      api.reload('d1f3b478', component.options)
    }
    module.hot.accept("./AnimationsModule.vue?vue&type=template&id=d1f3b478&scoped=true", function () {
      api.rerender('d1f3b478', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/AnimationsModule.vue"
export default component.exports